import BrowserStore from 'store';

const state = {
  activeTab: null,
  tabs: [
    { name: 'application' },
    { name: 'resume-default' },
    { name: 'comments' },
    { name: 'competences' },
    { name: 'test' },
    { name: 'answers' },
    { name: 'resume' },
    { name: 'team' },
    { name: 'questionnaire' },
    { name: 'test-specprocess' },
    { name: 'presentation' },
    { name: 'history' },
    { name: 'talentq' },
    { name: 'integration' },
    { name: 'additional' }
  ],
  // tab list for product (tab list in special process can be differ)
  tabsAvailable: [
    { name: 'application' },
    { name: 'resume-default' },
    { name: 'test' },
    { name: 'answers' },
    { name: 'comments' },
    { name: 'competences' },
    { name: 'history' },
    { name: 'integration' },
    { name: 'talentq' }
  ]
};

state.activeTab = BrowserStore.get('response:activeTab') || state.tabs[0];

const getters = {
  tabsAvailable(state) {
    return state.tabsAvailable;
  },

  activeTab(state) {
    return state.activeTab || {};
  }
};

const mutations = {
  setActiveTab(state, tab) {
    const currentTab = state.tabs.find(t => t.name === tab.name);

    if (!currentTab) {
      throw new Error(`Invalid tab name ${tab.name}`);
    }

    state.activeTab = currentTab;
    BrowserStore.set('response:activeTab', state.activeTab);
  }
};

const actions = {
  setActiveTab({ commit }, tab) {
    commit('setActiveTab', tab);
  },

  toggleBlock({ commit }, tab) {
    commit('setActiveTab', tab);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
